<template>
  <table class="custom-table" cellpadding="0" cellspacing="0">
    <thead>
      <tr>
        <th class="th-split">
          <div class="ab-class-pane">期限</div>
          <div class="ab-limit-pane">分类</div>
        </th>
        <template v-if="labelListObj[firstKeyName].list.length">
          <th
            v-for="item in labelListObj[firstKeyName].list"
            :key="`${item.startDate}_${item.endDate}`"
          >
            {{ item.startDate }}~{{ item.endDate }}
          </th>
        </template>
        <template v-else>
          <th>时间区间</th>
        </template>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="keyName in Object.keys(labelListObj)"
        :key="labelListObj[keyName].label"
      >
        <td>{{ labelListObj[keyName].label }}</td>
        <template v-if="labelListObj[keyName].list.length">
          <td
            v-for="item in labelListObj[keyName].list"
            :key="`${item.startDate}_${item.endDate}`"
          >
            <template v-if="keyName !== 'discreditExecutorList'">
              {{ item.amountOfMoney }} /
            </template>
            {{ item.numberOfTimes }}
          </td>
        </template>
        <template v-else>
          <td>暂无数据</td>
        </template>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['labelListObj', 'firstKeyName'],
}
</script>

<style lang="less" scoped>
.custom-table {
  width: 100%;
  max-width: 100%;
  min-width: 580px;
  text-align: center;
  border-left: 1px solid #e8e8e8;
  border-top: 1px solid #e8e8e8;
  overflow: hidden;
  margin: 0 auto;
  table-layout: fixed;
  tr th:first-child,
  tr td:first-child {
    width: 150px;
  }
  thead tr {
    background-color: #fafafa;
    color: #333339;
    height: 36px;
    line-height: 36px;
  }
  .th-split {
    position: relative;
    &::before {
      content: '';
      display: block;
      position: absolute;
      width: 109px;
      height: 1px;
      background: #e8e8e8;
      transform: scaleX(1.5) rotate(20deg);
    }
  }
  .ab-class-pane {
    position: absolute;
    bottom: -6px;
    left: 15px;
  }
  .ab-limit-pane {
    position: absolute;
    top: -6px;
    right: 12px;
  }
  tbody td,
  thead th {
    border-right: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
  }
}
</style>
